import React from 'react';
import Box from '@mui/material/Box';

import { Panel } from '../../../../../components/atoms/Panel';
import { FieldGrid, FieldItem } from '../../../../../components/atoms/FieldGrid';
import { sanitizeElement } from '../../../../../utils/common';
import { EquipmentFaultPanelProps } from './EquipmentFaultPanel.props';

/** Safely render notes that may contain HTML. */
const SafeHtml: React.FC<{ html: string }> = ({ html }) => {
  if (!html || html === '—') return <>{html}</>;
  if (/<[a-z][\s\S]*>/i.test(html)) {
    return (
      <Box
        component="span"
        sx={{ '& p': { m: 0 }, fontSize: 'inherit' }}
        dangerouslySetInnerHTML={{ __html: sanitizeElement(html) }}
      />
    );
  }
  return <>{html}</>;
};

export const EquipmentFaultPanel: React.FC<EquipmentFaultPanelProps> = ({
  service,
}) => {
  const creationNotes = service?.creationNotes ?? '—';

  return (
    <Panel title="Reported Information">
      <FieldGrid columns={2}>
        <FieldItem
          label="Reference #1"
          value={service?.referenceNo1 ?? '—'}
        />
        <FieldItem
          label="Reference #2"
          value={service?.referenceNo2 ?? '—'}
        />
        <FieldItem
          label="Reference #3"
          value={service?.referenceNo3 ?? '—'}
        />
        <FieldItem
          label="Model"
          value={service?.reportedModel ?? '—'}
        />
        <FieldItem
          label="Serial"
          value={service?.reportedSerialNumber ?? '—'}
        />
        <FieldItem
          label="Fault"
          value={service?.reportedFaultAndDescriptionId ? String(service.reportedFaultAndDescriptionId) : '—'}
        />
        <FieldItem
          label="Fault Description"
          value={service?.reportedFaultAndDescription ?? '—'}
          fullWidth
        />
        <FieldItem
          label="Reported Notes"
          value={<SafeHtml html={creationNotes} />}
          fullWidth
        />
      </FieldGrid>
    </Panel>
  );
};
